import { FC } from "react";
import { useParams } from "react-router-dom";
import { ErrorFallback, Loader } from "@/components";
import { SingleZoneUi } from "./SingleZone.ui";
import useSingleZone from "../../hooks/useSingleZone";

export const SingleZone: FC = (): JSX.Element => {
  const { slug } = useParams();

  const { zoneItem, loading, error } = useSingleZone(slug);

  if (error) {
    return <ErrorFallback>Failed to load Zone</ErrorFallback>;
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      {!loading && !error && (
        <>{zoneItem && <SingleZoneUi data={zoneItem as any} />}</>
      )}
    </>
  );
};
